<template>
  <div class="listing-actions">
    <button
      type="button"
      class="regenerate-yaml-btn"
      title="Regenerate YAML files"
      aria-label="Regenerate YAML files"
      @click="openRegeneration"
    >
      <b-icon icon="arrow-repeat" />
      <span>Regenerate YAML</span>
    </button>
    <button
      type="button"
      class="manage-mapping-btn"
      title="Manage Mapping Data"
      aria-label="Manage Mapping Data"
      @click="showMappingManager = true"
    >
      <b-icon icon="sliders" />
      <span>Manage Mapping Data</span>
    </button>

    <room-mapping-data-manager v-model="showMappingManager" />

    <b-modal
      v-model="showRegenerationModal"
      centered
      hide-footer
      title="Regenerate Room Mapping YAML"
    >
      <div class="regeneration-content">
        <p>Generate YAML files from the latest mapping data in the database.</p>

        <div v-if="regenerationError" class="regeneration-message error">
          {{ regenerationError }}
        </div>
        <div v-if="regenerationSuccess" class="regeneration-message success">
          {{ regenerationSuccess }}
        </div>

        <div class="regeneration-actions">
          <button
            type="button"
            class="cancel-regeneration-btn"
            :disabled="regenerationLoading"
            @click="showRegenerationModal = false"
          >
            Close
          </button>
          <button
            type="button"
            class="confirm-regeneration-btn"
            :disabled="regenerationLoading"
            @click="regenerateYaml"
          >
            <b-spinner v-if="regenerationLoading" small />
            <b-icon v-else icon="arrow-repeat" />
            {{ regenerationLoading ? 'Regenerating…' : 'Regenerate YAML' }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import { BIcon, BModal, BSpinner } from 'bootstrap-vue'
import RoomMappingDataManager from './RoomMappingDataManager.vue'

export default {
  name: 'RoomMappingListingActions',
  components: { BIcon, BModal, BSpinner, RoomMappingDataManager },
  data() {
    return {
      showMappingManager: false,
      showRegenerationModal: false,
      regenerationLoading: false,
      regenerationError: '',
      regenerationSuccess: '',
    }
  },
  methods: {
    openRegeneration() {
      this.showRegenerationModal = true
      this.regenerationError = ''
      this.regenerationSuccess = ''
    },
    async regenerateYaml() {
      this.regenerationLoading = true
      this.regenerationError = ''
      this.regenerationSuccess = ''
      try {
        const { data } = await axios.post('room_mapping_regenerate', {})
        this.regenerationSuccess = data.message || 'YAML files regenerated successfully.'
      } catch (error) {
        const apiMessage = error && error.response && error.response.data && error.response.data.message
        this.regenerationError = apiMessage || (error && error.message) || 'Please try again.'
      } finally {
        this.regenerationLoading = false
      }
    },
  },
}
</script>

<style scoped>
.listing-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.regenerate-yaml-btn,
.manage-mapping-btn {
  min-height: 40px;
  padding: 0 14px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
}
.regenerate-yaml-btn {
  border: 1px solid #6d28d9;
  color: #6d28d9;
  background: #fff;
}
.regenerate-yaml-btn:hover { background: #f5efff; }
.manage-mapping-btn {
  border: 1px solid #6d28d9;
  color: #fff;
  background: #6d28d9;
  box-shadow: 0 7px 16px rgba(109, 40, 217, .2);
}
.manage-mapping-btn:hover { background: #5b21b6; }
.regeneration-content > p {
  margin: 0 0 16px;
  color: #625b70;
  font-size: 13px;
  line-height: 1.55;
}
.regeneration-message {
  margin-top: 12px;
  padding: 11px 12px;
  border-radius: 9px;
  font-size: 12px;
  line-height: 1.5;
}
.regeneration-message.error {
  color: #a1263d;
  border: 1px solid #f2bdc8;
  background: #fff1f4;
}
.regeneration-message.success {
  color: #087443;
  border: 1px solid #a9e2c5;
  background: #edfff5;
}
.regeneration-actions {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
}
.regeneration-actions button {
  min-height: 39px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
}
.cancel-regeneration-btn {
  border: 1px solid #d9d1e5;
  color: #5f5570;
  background: #fff;
}
.confirm-regeneration-btn {
  border: 1px solid #6d28d9;
  color: #fff;
  background: #6d28d9;
}
.regeneration-actions button:disabled {
  cursor: not-allowed;
  opacity: .6;
}
@media (max-width: 768px) {
  .listing-actions { flex-wrap: wrap; }
  .regenerate-yaml-btn span,
  .manage-mapping-btn span { display: none; }
  .regenerate-yaml-btn,
  .manage-mapping-btn { width: 40px; padding: 0; }
}
</style>
